module.exports = __webpack_public_path__ + "static/img/15.b96c24c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/eng/15.png
// module id = sGOz
// module chunks = 0